/**
 * Womit jemand ein Board betritt.
 *
 * Zwischen dem Klick auf der Landingpage und der geöffneten Board-Ansicht
 * liegen ein API-Aufruf und ein Routenwechsel. Die Absicht — „ich will
 * zusehen", „ich will selbst vortragen" — überlebt beides nicht von allein: Der
 * Router kennt nur den Pfad, und die Board-Ansicht bekommt nur eine ID.
 *
 * Ein Modulwert reicht, weil dazwischen kein Neuladen im Browser liegt; der
 * Router tauscht bloß die Ansicht. Dieselbe Abwägung wie bei
 * `collab/initialDesign.ts` — und derselbe Grund, es *nicht* zu persistieren:
 * Ein Merkposten, der ein Neuladen überlebt, würde beim nächsten Öffnen
 * desselben Boards ungefragt einen Vortrag starten.
 */

const pendingTalk = new Set<string>()
const showcases = new Set<string>()

/** Dieses Board soll sofort im Vortragsmodus aufgehen. */
export const rememberTalkStart = (boardId: string): void => {
  pendingTalk.add(boardId)
}

/**
 * Soll hier ein Vortrag beginnen — genau einmal gefragt.
 *
 * Die Absicht wird beim Lesen vergessen, damit ein zweiter Aufbau derselben
 * Ansicht (etwa nach einem Verbindungsabbruch) den Vortrag nicht erneut
 * startet und den Zuschauer zurück auf Frame 1 wirft.
 */
export function takeTalkStart(boardId: string): boolean {
  return pendingTalk.delete(boardId)
}

/** Dieses Board wurde als Vorführung betreten. */
export const markShowcase = (boardId: string): void => {
  showcases.add(boardId)
}

/**
 * Ob dieses Board eine Vorführung ist.
 *
 * Anders als beim Vortragsstart bleibt die Auskunft bestehen: Die Leiste mit
 * dem Weg zum eigenen Versuch soll die ganze Zeit über zu sehen sein, nicht nur
 * im ersten Bild.
 */
export const isShowcaseVisit = (boardId: string): boolean => showcases.has(boardId)
